import { useState, useCallback } from 'react';
import { YEAR_EVENTS } from '../data/yearevents';
function shuffle(a){const b=[...a];for(let i=b.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[b[i],b[j]]=[b[j],b[i]];}return b;}
export default function YearGuesser({onBack,best,setBest}){
  const TOTAL=10;
  const [phase,setPhase]=useState('home');
  const [qs,setQs]=useState([]);
  const [qi,setQi]=useState(0);
  const [sel,setSel]=useState(null);
  const [score,setScore]=useState(0);
  const start=useCallback(()=>{
    setQs(shuffle(YEAR_EVENTS).slice(0,TOTAL));setQi(0);setSel(null);setScore(0);setPhase('play');
  },[]);
  const pick=useCallback((year)=>{
    if(sel!==null)return;setSel(year);
    const q=qs[qi];
    const pts=year===q.year?3:Math.abs(year-q.year)<=4?1:0;
    const ns=score+pts;setScore(ns);if(ns>best)setBest(ns);
  },[sel,qs,qi,score,best,setBest]);
  const next=useCallback(()=>{
    if(qi+1>=TOTAL){setPhase('over');return;}
    setQi(qi+1);setSel(null);
  },[qi]);
  const q=qs[qi],answered=sel!==null,pct=(qi/TOTAL)*100;
  const pts=answered&&q?(sel===q.year?3:Math.abs(sel-q.year)<=4?1:0):0;
  const grade=score>=25?'World Cup Historian':score>=18?'Time Traveller':score>=12?'Football Watcher':score>=6?'Vague Recollection':'Was You Even Born?';
  return(<div className="layer" style={{display:'flex',flexDirection:'column',minHeight:'100vh'}}>
    <div className="g-hdr">
      <button className="g-back" onClick={onBack}>← Menu</button>
      <div className="g-title" style={{color:'#facc15'}}>WHEN WAS IT?</div>
      {phase==='play'&&<div className="g-pills">
        <div className="g-pill yy"><span className="g-plbl">Score</span><span className="g-pval">{score}</span></div>
        <div className="g-pill"><span className="g-plbl">Best</span><span className="g-pval">{best}</span></div>
      </div>}
    </div>
    {phase==='home'&&<div className="game-home"><div className="game-inner">
      <div className="game-eye" style={{color:'#facc15',border:'1px solid #a16207'}}>World Cup History</div>
      <h1 className="game-big" style={{color:'#facc15'}}>WHEN WAS IT?</h1>
      <p className="game-desc">Iconic World Cup moment described. Guess the year.<br/><strong>3 pts</strong> exact · <strong>1 pt</strong> within 4 years.</p>
      {best>0&&<p className="game-best" style={{color:'#facc15'}}>Best: {best}</p>}
      <button style={{padding:'11px 34px',border:'none',borderRadius:10,background:'linear-gradient(135deg,#facc15,#a16207)',color:'#080f1e',fontFamily:"'Bebas Neue',sans-serif",fontSize:'1.25rem',letterSpacing:'0.1em',cursor:'pointer',marginTop:8}} onClick={start}>KICK OFF</button>
    </div></div>}
    {phase==='over'&&<div className="game-home"><div className="over-card">
      <div className="over-tag" style={{color:'#facc15',border:'1px solid #a16207'}}>TIME UP</div>
      <h1 className="over-h1">{grade}</h1>
      <div className="over-stats">
        <div className="over-stat"><span className="over-num" style={{color:'#facc15'}}>{score}</span><span className="over-lbl">Points</span></div>
        <div className="over-div"/>
        <div className="over-stat"><span className="over-num" style={{color:'#facc15'}}>{best}</span><span className="over-lbl">Best</span></div>
      </div>
      <button style={{padding:'11px 34px',border:'none',borderRadius:10,background:'linear-gradient(135deg,#facc15,#a16207)',color:'#080f1e',fontFamily:"'Bebas Neue',sans-serif",fontSize:'1.25rem',letterSpacing:'0.1em',cursor:'pointer'}} onClick={start}>PLAY AGAIN</button>
    </div></div>}
    {phase==='play'&&q&&<div className="game-body">
      <div className="prog-row"><div className="prog-bar"><div className="prog-fill-y" style={{width:pct+'%'}}/></div><span className="prog-pct">Q{qi+1}/{TOTAL}</span></div>
      <div className="year-event"><p className="year-event-text">{q.event}</p></div>
      <div className="year-choices">{q.opts.map((y,i)=>{
        let cls='year-choice';
        if(answered){if(y===q.year)cls='year-choice correct';else if(y===sel)cls='year-choice wrong';else cls='year-choice dim';}
        return <button key={i} className={cls} onClick={()=>pick(y)} disabled={answered}>{y}</button>;
      })}</div>
      {answered&&<>
        <div className={'result-box '+(pts>0?'ok':'no')}>
          <div className={'result-head '+(pts>0?'ok':'no')}>
            {sel===q.year?'Exact! +3 pts — '+q.year:pts===1?'Close! +1 pt — It was '+q.year:'Wrong — It was '+q.year}
          </div>
        </div>
        <div className="game-actions">
          <span className="remaining">{qi+1<TOTAL?(TOTAL-qi-1)+' left':'Last!'}</span>
          <button className="btn-next y" onClick={next}>{qi+1>=TOTAL?'Results →':'Next →'}</button>
        </div>
      </>}
    </div>}
  </div>);
}
